import * as yup from "yup";
import {
  BROADCAST_MIN_SCHEDULED_TIME_MINUTES,
  BROADCAST_SEND_TYPE,
} from "../constants/broadcast";

export const broadcastNameSchema = yup.object().shape({
  broadcastName: yup
    .string()
    .required("El nombre de la campaña es requerido")
    .min(3, "El nombre debe tener al menos 3 caracteres")
    .max(50, "El nombre no puede exceder 50 caracteres")
    .trim()
    .matches(
      /^[a-zA-Z0-9_ ñÑ]+$/,
      "El nombre debe contener solo letras, números y espacios",
    ),
});

export const broadcastActionsSchema = yup.object().shape({
  actions: yup.array().of(
    yup.object().shape({
      label: yup.string().required("El texto del botón es requerido"),

      agents: yup
        .array()
        .of(yup.string().required("El agente es requerido"))
        .max(1, "Solo se puede asignar un agente")
        .optional(),

      assignation: yup.string().oneOf(["DIRECT"]).optional(),

      tags: yup
        .array()
        .of(yup.string().required("El tag es requerido"))
        .max(3, "Solo se puede asignar 3 etiquetas")
        .optional(),

      mediaUrl: yup.string().optional(),

      message: yup.string().required("El mensaje es requerido").optional(),

      //   botIntents: yup.array().of(
      //     yup.object().shape({
      //       name: yup.string().required("El nombre del intent es requerido"),
      //       nextId: yup.string().optional(),
      //     })
      //   ).optional(),
    }),
  ),
});

export const scheduleBroadcastSchema = yup.object().shape({
  sendType: yup
    .string()
    .oneOf(
      [BROADCAST_SEND_TYPE.NOW, BROADCAST_SEND_TYPE.SCHEDULED],
      "Tipo de envío es requerido",
    )
    .required(),

  scheduledDate: yup.string().when("sendType", {
    is: BROADCAST_SEND_TYPE.SCHEDULED,
    then: (schema) =>
      schema
        .required("Fecha es requerida")
        .test(
          "min-date",
          "La fecha no puede ser menor a hoy",
          function (value) {
            if (!value) return true;

            const now = new Date();
            const today = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
            );
            const selected = new Date(value + "T00:00:00");

            return selected.getTime() >= today.getTime();
          },
        ),
    otherwise: (schema) => schema.notRequired(),
  }),

  scheduledTime: yup.string().when("sendType", {
    is: BROADCAST_SEND_TYPE.SCHEDULED,
    then: (schema) =>
      schema
        .required("Hora es requerida")
        .test(
          "is-future-time",
          `La hora debe ser al menos ${BROADCAST_MIN_SCHEDULED_TIME_MINUTES} minutos posterior a la actual`,
          function (value) {
            const { scheduledDate } = this.parent;
            if (!scheduledDate || !value) return true;

            const now = new Date();
            const selectedDate = new Date(scheduledDate + "T00:00:00");
            const todayDateOnly = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
            );

            if (selectedDate.getTime() !== todayDateOnly.getTime()) {
              return true;
            }

            const [hours, minutes] = value.split(":").map(Number);

            const selectedDateTime = new Date(
              now.getFullYear(),
              now.getMonth(),
              now.getDate(),
              hours,
              minutes,
            );

            const minAllowedTime = new Date(
              now.getTime() + BROADCAST_MIN_SCHEDULED_TIME_MINUTES * 60000,
            );

            if (selectedDateTime < minAllowedTime) {
              return false;
            }

            return true;
          },
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const whatsAppNotificationSchema = yup.object().shape({
  phonesToNotify: yup
    .array()
    .of(yup.string().required("El teléfono es requerido"))
    .max(8, "Solo se pueden seleccionar 8 teléfonos")
    .optional(),
});
